import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';

export default function CustomerSupportPhone() {

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  var phone = "(877) 449-6387";

  if (accountObj && accountObj.account && accountObj.account.phone) {
    phone = accountObj.account.phone;
  }

  return phone;
}
